export default __webpack_public_path__ + "static/media/menu_control.3d9cd309.png";